export enum RunStatus {
    Started =  "STARTED",
    Running = "RUNNING",
    Success = "SUCCESS",
    Failure = "FAILURE"
}